import { render } from "./Orientations.vue?vue&type=template&id=5a0ef3a2&scoped=true"
import script from "./Orientations.vue?vue&type=script&lang=js"
export * from "./Orientations.vue?vue&type=script&lang=js"

import "./Orientations.vue?vue&type=style&index=0&id=5a0ef3a2&scoped=true&lang=sass"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0ef3a2"]])

export default __exports__